module.exports = ".bold {\r\n  font-weight: 700;\r\n}\r\n\r\n.block {\r\n  display: inline-block;\r\n}\r\n\r\ndiv.inline-edit {\r\n  text-decoration: none;\r\n  border-bottom: #A8B9CE dashed 1px;\r\n  cursor: pointer;\r\n  text-align: left;\r\n  padding: 0;\r\n  color: #444 !important;\r\n  width: auto;\r\n}\r\n\r\n:host.ng-invalid .inline-edit {\r\n  border-bottom: #ff0000 dashed 1px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/component/alps-inline-edit/alps-inline-edit.component.css
// module id = 504
// module chunks = 16